import './handels/style';
import FormStructure from './handels/form_structure';

export default FormStructure;